<div *ngIf="agency" class="row mx-3 my-2">
    <div class="col-12">
    <form id="frmAgency" #frmAgency="ngForm" style="width:100%;">
    <div class="card bg-gradient" [ngClass]="{'bg-lightblue': canAdd, 'bg-light': !canAdd}">
        <div class="card-body">
            <div class="row">
                <div class="col-6">
                    <label for="Designation" class="control-label" paflabel="Nom_de_l_agence"></label>
                    <input type="text" class="form-control" id="Designation" name="Designation" [(ngModel)]="agency.Designation" required [disabled]="readonly">
                    <validation-errors [form]="frmAgency" controlName="Designation"></validation-errors>
                </div>
                <div class="col-2">
                    <label class="control-label" paflabel="Code_SIRET"></label>
                    <input type="text" class="form-control" name="agencySiret" [(ngModel)]="agency.Siret" maxlength="14" 
                    siretValidator siretActif required [disabled]="readonly">
                    <validation-errors [form]="frmAgency" controlName="agencySiret"></validation-errors>
                </div>
                <div class="col-4 text-right" *ngIf="!readonly">
                    <button *ngIf="canDelete" type="button" class="btn btn-danger btn-sm  float-end" (click)="onDelete()"><i
                            class="fa fa-store-slash"></i></button>
                    <button *ngIf="canAdd" type="button" class="btn btn-success btn-sm  float-end" (click)="onAdd()"><i
                            class="fa fa-store"></i></button>
                </div>
            </div>
            <div *ngIf="agency.Address">
                <div class="row">
                    <div class="col">
                        <label class="control-label" paflabel="Adresse"></label>
                    </div>                       
                </div>
                <div class="d-flex">
                        <input type="text" class="form-control" name="AddrNum" [(ngModel)]="agency.Address.AddrNum" style="width:60px;" [disabled]="readonly">
                    
                    <div>
                        <input type="text" class="form-control" name="Addr1" [(ngModel)]="agency.Address.Addr1"  style="width:600px;" required [disabled]="readonly">
                        <validation-errors [form]="frmAgency" controlName="Addr1"></validation-errors>
                    </div>
                </div>
                <div class="d-flex mt-1">
                        <input type="text" class="form-control" name="Addr2" [(ngModel)]="agency.Address.Addr2" style="width:660px;" [disabled]="readonly">
                        <label class="control-label ml-1" paflabel="Code_postal" ></label>
                        <input type="text" class="form-control" name="PostalCod" maxlength="16" [(ngModel)]="agency.Address.PostalCod" style="width:150px;" required  [disabled]="readonly">
                        <validation-errors [form]="frmAgency" controlName="PostalCod"></validation-errors>
                        <label class="control-label ml-1" paflabel="Ville"></label>
                        <div class="flex-grow-1">
                            <input type="text" class="form-control" name="City" [(ngModel)]="agency.Address.City" required style="width:100%" [disabled]="readonly">
                            <validation-errors [form]="frmAgency" controlName="City"></validation-errors>

                        </div>
                </div>
            </div>
        </div>
    </div>
</form>
</div></div>